import { api } from "../../http";

async function PostDataAllRRIM(data) {
  try {
    console.log("DADOS ENVIADOS:", data);
    const rrim = await api.post("/rrim/", data);
    return rrim;

  } catch (e) {
    console.log(e.message);
    console.log("STATUS:", e.response.status);
    console.log("RESPOSTA DO BACKEND:", e.response.data);
  }
}

export { PostDataAllRRIM };
